import { render, staticRenderFns } from "./GeneralSettingDeliveryBlackoutsHours.vue?vue&type=template&id=4f3725b0&"
import script from "./GeneralSettingDeliveryBlackoutsHours.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingDeliveryBlackoutsHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports